import { LegalDocument } from '@/legal/components/LegalDocument';
import { SubprocessorSubscribeForm } from '@/components/consent/SubprocessorSubscribeForm';
import content from '@/legal/content/subprocessors-ru-v1.0.md?raw';

export function SubprocessorsPage() {
  return (
    <LegalDocument
      title="Sub-processors"
      content={content}
      version="1.0"
      effectiveDate="2026-05-07"
      readingMinutes={5}
      jurisdictions={['ru', 'eu', 'us']}
    >
      <SubprocessorSubscribeForm />
    </LegalDocument>
  );
}
